module.exports = __webpack_public_path__ + "img/avatar6.3a438271.png";